import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BrowserView, MobileView } from 'react-device-detect';

const BlockRight = ({ data }) => {
  const [width, setWidth] = useState();
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const heightCalc = () => {
    const width = document.body.offsetWidth;
    if (width > 640) {
      let height = width * 0.74;
      return height;
    } else if (width <= 640) {
      let height = width * 3.275;
      return height;
    }
  };
  let dynamicHeight = heightCalc();

  const mainVariant = {
    hidden: {
      opacity: 0.5
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.5,
        type: ' tween'
      }
    }
  };

  const childrenVariant = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const desktop = (
    <div
      className="blockRight"
      style={{ backgroundImage: `url(${data.background})`, height: dynamicHeight }}
    >
      <motion.div
        variants={mainVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        className="blockRight__mainCont"
      >
        <img src={data.mainImg} alt="little girl" />
        <motion.div variants={childrenVariant} className="blockRight__thumbnails">
          <img src={data.tn1} alt="thumbnail" />
          <img src={data.tn2} alt="thumbnail" />
        </motion.div>
        <motion.div variants={childrenVariant} className="paragraphCont">
          <h2>{data.header}</h2>
          <a href={data.link} rel="sponsored">
            <button>
              <svg
                width="12"
                height="15"
                viewBox="0 0 12 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 7.5L0 15L6.05683e-07 0L12 7.5Z" fill="white" />
              </svg>
              {data.buttonCopy}
            </button>
          </a>
          <p>{data.paragraph}</p>
        </motion.div>
      </motion.div>
    </div>
  );

  const mobile = (
    <div
      className="blockLeftMobile"
      style={{ backgroundImage: `url(${data.backgroundM})`, height: dynamicHeight }}
    >
      <div className="blockLeftMobile__mainImgCont">
        <img src={data.mainImgM} alt="little girl in space suit" />
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 1.5 }}
        className="blockLeftMobile__paragraphsCont"
      >
        <h2>{data.header}</h2>
        <a href={data.link} rel="sponsored">
          <button className={data.id === 'block2' ? 'disabled' : 'watchFilm'}>
            <svg
              width="12"
              height="15"
              viewBox="0 0 12 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12 7.5L0 15L6.05683e-07 0L12 7.5Z" fill="white" />
            </svg>

            {data.buttonCopy}
          </button>
        </a>
        <p>{data.paragraph}</p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 1.5 }}
        className="blockLeftMobile__thumbnails"
      >
        <img src={data.tn1} alt="thumbnail" />
        <img src={data.tn2} alt="thumbnail" />
      </motion.div>
    </div>
  );

  return (
    <>
      <BrowserView>{width < 600 ? mobile : desktop}</BrowserView> <MobileView>{mobile}</MobileView>
    </>
  );
};

export default BlockRight;
